import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push, goBack } from 'redux-first-history';
import intl from 'react-intl-universal';
import { saveCaseDataCollectQuestionnairePage } from 'src/services/questionnaire.service.js';
import {
  getQuestionnairePage,
  getQuestionnaireProfile,
  setShowProfileIconNameState,
  toggleSpinner,
  resetQuestionnaire,
  updatePageData,
  setCaseSubmitted,
  resetReloadFlag,
  setCaseDetail,
  setRefreshPageStatus,
} from 'src/new-ui/features/CaseDataCollect/state/caseDataCollectAction';
import { fetchEmployersLookupValues, fetchClientLookupValues } from 'src/services/accounts.service';
import QuestionnairePagePres from '../Presentation/QuestionnairePagePres';
import { addToHistory } from 'src/utils/utilsActions';
import { CREATEORGANIZER_PAGESTATES } from 'src/constants/constants';
import { PageTitle } from 'src/ui/library/PageTitle';
import { transformFormValues } from 'src/helpers';
import { withSnackbar } from 'notistack';
import _ from 'lodash';
import { fnGetCaseRelatedId, fnResetPageState, fnIsPageCompleted } from 'src/helpers/commonFunctions';
import { formDataDifference } from 'src/helpers/formDataDifference.js';

class QuestionnairePageContainer extends Component {
  static propTypes = {
    caseId: PropTypes.string,
  };
  state = {
    formValues: {},
    isSaveLoading: false,
    expandedMenu: null,
    caseDataMenu: null,
    isPageLoaded: false,
    isCheckboxChecked: false,
    rows: [],
    clientLookup: [],
    prevMenuCompleted: false,
    isCheckboxUpdated: false,
    initialFormData: {},
  };

  constructor(props) {
    super(props);
    this.updatePageDataFunction = this.props.updatePageData;
    this.validateFn = () => {};
    this.timer = 0;
    this.autoSaveEnabled = false;
  }

  componentDidMount() {
    this.props.addToHistory(window.location.pathname);
    // Load the questionnaire's first page and update the URL.
    if (!this.props.pageData.pageId) {
      if (
        this.props.match.params.pageId !== '00000000-0000-0000-0000-000000000000' &&
        this.props.match.params.sectionId !== '00000000-0000-0000-0000-000000000000'
      ) {
        //do not run getpagedata for review and submit
        this.getPageData().then(res => {
          if (res && !res.error && !res.errors) {
            if (this.props.pageData) {
              this.props.getQuestionnaireProfile(this.props.pageData.entityId);
            }
          }
        });
      }

      this.props.updatePageData(this.props.pageData);
    }
    this.setState({ caseDataMenu: this.props.caseDatacollectMenu });
    this.setState({ isPageLoaded: true });
    this.props.setShowProfileIconNameState(true);
    fetchEmployersLookupValues({
      filter: true,
      sortDirection: 'asc',
      pageSize: 100,
      pageNumber: 1,
    }).then(response => {
      if (response && response.rows) {
        const data = response.rows.map((row, index) => ({ ...row, index }));
        this.setState({ rows: data });
      }
    });

    fetchClientLookupValues({
      filter: true,
      sortDirection: 'asc',
      searchText: '',
      pageSize: 100,
      pageNumber: 1,
    }).then(response => {
      if (response && response.rows) {
        const data = response.rows.map((row, index) => ({ ...row, index }));
        this.setState({ clientLookup: data });
      }
    });
  }

  componentWillUnmount() {
    if (
      !this.props.pageData.isSubmitted &&
      ((!_.isEmpty(this.props.pageData) && !this.props.pageData.isMultiline) || this.state.isCheckboxUpdated)
    ) {
      this.handleSave(false, false, false);
    }
    this.props.resetQuestionnaire();
    this.props.setShowProfileIconNameState(false);
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = 0;
    }
  }

  fnIsLastPage(flag) {
    let menu = _.nth(
      this.props.caseDatacollectMenu.menuDetails.filter(x => x.pageId === fnGetCaseRelatedId(3)),
      0,
    );
    let pageIndex = menu.subMenu.findIndex(x => x.pageId === fnGetCaseRelatedId(4));
    let isLastPage = menu.subMenu.length === 1 || menu.subMenu.length === pageIndex + 2;
    if (flag) return isLastPage;
    return { menu, isLastPage, pageIndex };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isReloaded) {
      let { menu, isLastPage, pageIndex } = this.fnIsLastPage();
      if (isLastPage) {
        let isPageCompleted =
          isLastPage && menu.subMenu.filter((x, i) => x.pageState.toLowerCase() !== 'complete' && i !== pageIndex).length === 1;
        this.props.resetReloadFlag();
        if (isPageCompleted) {
          sessionStorage.setItem('page_reset', true);
        }
      }
    }
    if (this.props.match.params.pageId === '00000000-0000-0000-0000-000000000000') {
      this.autoSaveEnabled = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = 0;
      }
    }
    this.saveOnChange(prevProps);
  }

  saveOnChange = async prevProps => {
    if (
      prevProps.match.params.pageId !== '00000000-0000-0000-0000-000000000000' &&
      prevProps.match.params.pageId !== this.props.match.params.pageId &&
      !this.props.pageData.isSubmitted &&
      ((!_.isEmpty(this.props.pageData) && !this.props.pageData.isMultiline) || this.state.isCheckboxUpdated)
    ) {
      this.handleSave(false, false, false);
    }
    if (
      this.props.match.params.pageId !== '00000000-0000-0000-0000-000000000000' &&
      this.props.match.params.sectionId !== '00000000-0000-0000-0000-000000000000'
    ) {
      //bypass ReviewandSubmit Page
      if (prevProps.match.params.pageId !== this.props.match.params.pageId) {
        this.getPageData();
        this.setState({ isCheckboxChecked: false, isCheckboxUpdated: false });
      }
      /** handle save only for singleline questionnaire - autosave is enabled */
      if (this.props.isApplicant && typeof this.props.pageData === 'object' && !this.props.pageData.isMultiline) {
        const { isAutoSaveEnabled, timeInterval } = this.props.pageData;
        if (isAutoSaveEnabled && timeInterval && !this.autoSaveEnabled && this.timer === 0) {
          this.autoSaveEnabled = isAutoSaveEnabled;
          this.timer = setInterval(() => {
            this.handleSave(false, false, false);
          }, timeInterval * 1000);
        }
      }
      if (!_.isEmpty(this.props.pageData) && this.props.pageData.isMultiline) {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = 0;
        }
      }
    }
  };

  getPageData = () => {
    const { getQuestionnairePage, match } = this.props;
    const useMock = false;
    this.props.match.params.entityId = this.props.match.params.sectionId;
    return new Promise((resolve, reject) =>
      getQuestionnairePage({ ...match.params, sectionName: undefined }, useMock)
        .then(res => {
          resolve(res);
          this.setState({ isPageLoaded: true });
        })
        .catch(e => {
          this.props.toggleSpinner(false);
          if (this.props.enqueueSnackbar) {
            this.props.enqueueSnackbar(e.message, { variant: 'error' });
          }
          this.props.goBack();
          reject(e);
        }),
    );
  };

  handlePageStatusRefresh = () => {
    const { entityId: questionaireId, pageId, isSubmitted } = this.props.pageData;
    if (fnIsPageCompleted(this.props.caseDatacollectMenu.menuDetails, questionaireId, pageId) && !isSubmitted) {
      const menuObj = fnResetPageState(this.props.caseDatacollectMenu.menuDetails, questionaireId, pageId);
      this.props.setCaseDetail(menuObj, true);
      this.props.setRefreshPageStatus(true);
    }
  };

  setFormValues = formValues => {
    if (!formValues.isFormComplete) {
      this.handlePageStatusRefresh();
    }
    this.updatePageDataFunction(formValues);
    if (Object.keys(formValues).length > 0 && formValues.elementUpdated === null) {
      const dataRequest = _.cloneDeep(formValues);
      this.setState({ initialFormData: dataRequest });
    }
    this.setState({ formValues });
  };

  setValidationFn = validateFn => {
    this.validateFn = validateFn;
  };

  setPageLoading = flag => {
    this.setState({ isPageLoaded: flag });
  };

  setCheckboxChecked = flag => {
    if (this.state.isCheckboxChecked && !flag) {
      this.handlePageStatusRefresh();
    }
    this.setState({ isCheckboxChecked: flag });
  };
  setCheckboxUpdated = flag => {
    this.setState({ isCheckboxUpdated: flag });
  };

  handleSave = async (showNotification = true, isSubmitted = false, validateForm = true) => {
    const { enqueueSnackbar, pageData } = this.props;

    const { formValues, isFormComplete } = this.state.formValues;

    if (!pageData.isMultiline) {
      if (validateForm && !isFormComplete && !this.validateFn()) {
        const message = 'Please review form validation errors';
        enqueueSnackbar(message, { variant: 'error' });
        throw new Error(message);
      }
    }

    const { organizerInstanceId, entityId, yearTypeId, organizerTypeId, pageId, sourceTableId } = this.props.pageData;
    const pageState = isFormComplete ? CREATEORGANIZER_PAGESTATES.COMPLETE : CREATEORGANIZER_PAGESTATES.CURRENT_NOT_COMPLETE;

    let formData = { ...formValues };

    formData.dataRequests =
      Object.keys(this.state.initialFormData).length > 0
        ? formDataDifference(formValues.dataRequests, this.state.initialFormData.formValues.dataRequests)
        : formValues.dataRequests;

    const orgOptions = pageData.isMultiline
      ? {
          entityId,
          organizerInstanceId,
          organizerTypeId,
          yearTypeId,
          pageId,
          pageSourceId: sourceTableId,
          languageId: 1,
          pageState,
          isSubmitted,
          dataRequests: [],
          tables: [],
        }
      : {
          entityId,
          organizerInstanceId,
          organizerTypeId,
          yearTypeId,
          pageId,
          pageSourceId: sourceTableId,
          languageId: 1,
          pageState,
          isSubmitted,
          ...transformFormValues(formData),
        };

    let result;
    try {
      result = await saveCaseDataCollectQuestionnairePage(orgOptions).catch(e => {
        this.props.toggleSpinner(false);
        throw e;
      });
    } catch (e) {
      this.props.toggleSpinner(false);
      this.setState({ isPageLoaded: true });
      throw e;
    }

    if (result && result.success) {
      this.props.setCaseSubmitted(true);
      if (showNotification) {
        enqueueSnackbar('Saved Successful', { variant: 'success' });
      }
    } else if (result.error) {
      enqueueSnackbar(result.error.message, { variant: 'error' });
      throw Error(result.error.message);
    }
  };

  gotoPage = isNext => {
    const { caseDataMenu } = this.state;
    const { history, location } = this.props;
    let menu = _.nth(
      caseDataMenu.menuDetails.filter(x => x.pageId === _.nth(location.pathname.split('/'), 3)),
      0,
    );
    let menuIndex = menu.subMenu.findIndex(x => x.pageId === _.nth(location.pathname.split('/'), 4));
    if (menuIndex >= 0) {
      const newPageId = menu.subMenu[isNext ? menuIndex + 1 : menuIndex - 1].pageId;
      this.setState({ isSaveLoading: false, isPageLoaded: true });
      history.push('/case-data/' + _.nth(location.pathname.split('/'), 2) + '/' + _.nth(location.pathname.split('/'), 3) + '/' + newPageId);
    }
  };

  handleMenuExpand = menuName => {
    this.setState({ expandedMenu: menuName });
  };

  handleSaveProgress = () => {
    this.setState({ isSaveLoading: true });
    this.handleSave(true, false, false).then(() => {
      this.setState({ isSaveLoading: false });
    });
  };

  handlePage = isNext => {
    this.setState({ isSaveLoading: true, isPageLoaded: false });
    this.handleSave(false, false).then(() => {
      this.gotoPage(isNext);
    });
  };

  render() {
    const { caseDatacollectMenu, formValues } = this.props.state;
    const activeQuestionnaire = _.head(
      this.props.caseDatacollectMenu.menuDetails.filter(x => x.pageId === this.props.match.params.sectionId),
    );
    return (
      <React.Fragment>
        <div className="questionnarie-main-container">
          <PageTitle title={intl.get('questionnaire.subTitles.details')} />
          <QuestionnairePagePres
            formValues={formValues}
            curExpandedMenu={this.state.expandedMenu}
            setFormValues={this.setFormValues}
            setValidationFn={this.setValidationFn}
            handleSave={this.handleSave}
            onSaveExit={this.handleSaveAndExit}
            gotoPage={this.gotoPage}
            isFirstPage={caseDatacollectMenu && caseDatacollectMenu.menuIndex === 0}
            isLastPage={this.fnIsLastPage(true)}
            isReviewEnabled={
              caseDatacollectMenu &&
              caseDatacollectMenu.menu.length !== 1 &&
              caseDatacollectMenu.menu.length === caseDatacollectMenu.menuIndex + 1 &&
              activeQuestionnaire.subMenu.filter((x, i) => x.pageState.toLowerCase() !== 'complete' && i < caseDatacollectMenu.menuIndex)
                .length > 0
            }
            isPageLoaded={this.state.isPageLoaded}
            setPageLoading={this.setPageLoading}
            handleSaveProgress={this.handleSaveProgress}
            onMenuExpand={this.handleMenuExpand}
            isSaveLoading={this.state.isSaveLoading}
            handlePage={this.handlePage}
            setCheckboxChecked={this.setCheckboxChecked}
            isCheckboxChecked={this.state.isCheckboxChecked}
            isCheckboxUpdated={this.state.isCheckboxUpdated}
            setCheckboxUpdated={this.setCheckboxUpdated}
            caseHeaderDetails={this.props.casedetails}
            {...this.props}
            {...this.state}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.caseDatacollectMenu.isLoading,
  pageData: state.caseDatacollectMenu.page,
  isTablet: state.browser.greaterThan.small && state.browser.is.medium,
  isMobile: state.browser.is.small || state.browser.is.extraSmall,
  userInfo: state.login.userInfo,
  isApplicant: state.login.userRoles.applicant,
  state: state,
  caseDatacollectMenu: state.caseDatacollectMenu,
  isReloaded: state.caseDatacollectMenu.isReloaded,
  casedetails: state.caseDatacollectMenu.caseHeaderDetails,
});

const mapDispatchToProps = {
  getQuestionnairePage,
  resetQuestionnaire,
  getQuestionnaireProfile,
  setShowProfileIconNameState,
  push,
  goBack,
  toggleSpinner,
  addToHistory,
  updatePageData,
  setCaseSubmitted,
  resetReloadFlag,
  setCaseDetail,
  setRefreshPageStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(QuestionnairePageContainer));
